import { Action } from '../types/Action';
import { State } from '../types/State';

export default (state: State, action: Action): State => {
    switch (action.type) {
        case 'request_started':
            return {
                ...state,
                endpoint: action.endpoint,
                status: 'loading',
                additionalInfo: action.additionalInfo,
                isLoading: true,
                error: null,
            };
        case 'request_successful':
            return {
                ...state,
                status: 'success',
                endpoint: action.endpoint,
                result: action.result,
                additionalInfo: action.additionalInfo,
                isLoading: false,
                error: null,
            };
        case 'request_failed':
            return {
                ...state,
                endpoint: action.endpoint,
                status: 'error',
                additionalInfo: action.additionalInfo,
                isLoading: false,
                error: action.error,
            };

        default:
            return state;
    }
};
